import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-errors',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './errors.component.html',
    styleUrls: ['./errors.component.scss'],
    standalone: false
})
export class ErrorsComponent {
  /**
   * Constructor
   *
   * @param navigationControlService
   */
  public constructor(public navigationControlService: NavigationControlService) {
  }

  /**
   * Go To Home
   */
  goToHomepage() {
    this.navigationControlService.goHome();
  }
}
